import styles from "../../assets/css/pane.module.scss";
import VerticalStepper from "../../components/steppers/VerticalStepper";
import { STEPS } from "../../constants";
import AboundLogo from "../../assets/img/aboundlogo.svg";
import qr from "../../assets/img/qr1.png";
import googleplay from "../../assets/img/G-Play.png";
import applestore from "../../assets/img/A-Store.png";
// import unlcokallfeature from "../../assets/img/unlcokallfeature.svg";
import SkeletonBox from "./SkeletonBox";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { downloadApp, goToAbound } from "../../libs/utils";

const RemittanceDashboardLeftPane = () => {
  const [nbInfo, setNbInfo] = useState({
    isNbLoaded: false,
    currentStep: -1,
  });
  const { nbStatusInfo } = useSelector((state) => state.remittance);

  useEffect(() => {
    if (nbStatusInfo) {
      setNbInfo(nbStatusInfo);
    }
  }, [nbStatusInfo]);

  const { isNbLoaded, currentStep } = nbInfo;

  const isLoading = !isNbLoaded || !currentStep;

  const isCompletedAllTasks = currentStep === 3;

  return (
    <div className={styles.leftPane}>
      <div className={styles.logoContainer} onClick={goToAbound}>
        <img
          className={styles.logo}
          src="https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/Website%2BRemittance/aboundlogo.svg"
          alt="AboundLogo"
        />
      </div>
      <div className={styles.dashboardMainContainer}>
        <div
          className={
            isLoading
              ? `${styles.leftDashboardPane} ${styles.leftDashboardPaneSkelton}`
              : styles.leftDashboardPane
          }
        >
          {isLoading ? (
            <div>
              <SkeletonBox />
              <SkeletonBox />
              <SkeletonBox />
            </div>
          ) : (
            <>
              <div
                className={
                  isCompletedAllTasks
                    ? `${styles.leftPaneImageContainer} ${styles.leftPaneImageContainerBg}`
                    : styles.leftPaneImageContainer
                }
              >
                {isCompletedAllTasks ? (
                  <img
                    className={styles.leftpaneImg}
                    src="https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/Website%2BRemittance/unlcokallfeature.svg"
                    alt="LeftPaneImage"
                  />
                ) : (
                  // <Unlcokallfeature />
                  <div className={styles.stepper}>
                    <VerticalStepper steps={STEPS} activeStep={currentStep} />
                  </div>
                )}
              </div>

              <div
                className={
                  isCompletedAllTasks
                    ? `${styles.downloadAppContainer} ${styles.downloadAppContainerAllTaskCompleted}`
                    : styles.downloadAppContainer
                }
              >
                <div className={styles.downloadText}>Download App here:</div>
                <div className={styles.downloadBox}>
                  <div>
                    <img src={qr} className={styles.qrImage} />
                  </div>
                  <div className={styles.appLogoImageBox}>
                    <div onClick={() => downloadApp("iOS")}>
                      <img
                        src={applestore}
                        alt="Click Here to Get iOS App"
                        className={styles.appLogo}
                      />
                    </div>
                    <div onClick={() => downloadApp("android")}>
                      <img
                        src={googleplay}
                        alt="Click here to get Android App"
                        className={styles.appLogo}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default RemittanceDashboardLeftPane;
